function impactCounter() {

    if ( $('.impact-counter').length ) {
        const impactCounter = $('.impact-counter'),
              endingNum = impactCounter.attr('data-end'),
              odometer = document.querySelector('.odometer');

        $(window).scroll(function() {
            if (isScrolledIntoView(odometer, 200)) {
                odometer.innerHTML = endingNum;
            }
        });
    }    

}